import React from 'react';
import Button, { buttonVariants } from '@weave-mui/button';
import StandardEmptyState from '../../components/StandardEmptyState';

/**
 * Empty state component displayed when a project has no test cases
 * @param {Object} props - Component props
 * @param {Function} props.onAddTest - Callback function when Add a test button is clicked
 * @param {boolean} [props.isAdmin=false] - Whether the user is an admin
 */
const EmptyTestCasesState = ({ onAddTest, isAdmin = false }) => {
  return (
    <StandardEmptyState
      headline="No test cases yet"
      tagline="There are no test cases added yet."
      supportingText={isAdmin ? 'Click on Add a test to get started.' : ''}
      callToAction={
        isAdmin ? (
          <Button variant={buttonVariants.CONTAINED} onClick={onAddTest}>
            Add a test
          </Button>
        ) : undefined
      }
    />
  );
};

export default EmptyTestCasesState;
